module.exports = __webpack_public_path__ + "img/CodeOutlined.e81e7cdb.svg";